import { useOutletContext } from "react-router-dom"

const useSponsor = sponsorId => {
  const { sponsorsMap } = useOutletContext()

  return sponsorsMap[sponsorId] || {}
}

export default useSponsor
